import React, { useState, useEffect } from "react";
// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import GUI_InputTextArea from "./gui/GUI_InputTextArea";
// import GUIset_Single from "./gui/GUIset_TextArea";
import GUIset_TextArea from "./gui/GUIset_TextArea";
import Template from "./TheTemplate";
import T from "./TheTool";
import Timer from "./TheTimer";

const ArrayRotation = () => {
	useEffect(() => {
		document.title = "Array Rotation";
	}, []);

	const [guiTxtArea, guiTxtAreaChange] = useState(
		"1,2,3,4\n1,2,3,4,5,6,7\n3,4,5,6,7,1,2\n3,4,5,6,7\n6,5,4,3,7\n2,3,4,5\n3,2,1,4"
	);
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxtArea != "") {
			process_bulk();
			BuildResult();
		}
	};

	var txt_input = "";
	var txt_result = "";
	var txt_time = "";

	function process_bulk() {
		var arrs = T.str_toListArray_noEmpty(guiTxtArea,",");
		txt_input = "";
		txt_result = "";
		//
		for (var i = 0; i < arrs.length; i++) {
			if(txt_input != ""){ txt_input +="\n";}
			txt_input += "#" + i + " : " + arrs[i];
		}
		//
		Timer.start();
		//
		for (var i = 0; i < arrs.length; i++) {
			for (var j = i + 1; j < arrs.length; j++) {
				if (arrs[i].length == arrs[j].length) {
					process(i, j, arrs[i], arrs[j]);
				}
			}
		}
		//
		txt_time = Timer.stop_print();
	}

	function process(i, j, arr1, arr2) {
		var o = isRotated(arr1, arr2);
		if (o != "") {
			if(txt_result != ""){ txt_result +="\n";}
			txt_result += "#" + i + " #" + j + " : " + o;
		}
	}

	function isRotated(arr1, arr2) {
		// console.log(arr1 + " vs " + arr2);
		var output = "";
		for (var a = 0; a < arr2.length; a++) {
			if (arr1[0] == arr2[a]) {
				//Direct Rotation
				var found = true;
				for (var b = 1; b < arr1.length; b++) {
					var x = a + b;
					if(x >= arr2.length) { x -= arr2.length; }
					if(arr1[b] != arr2[x]){ found = false; break; }
				}
				if(found) { output = "Rotation"; break; }
				//Reverse Rotation
				found = true;
				for (var b = 1; b < arr1.length; b++) {
					var x = a - b;
					if(x < 0) { x += arr2.length; }
					if(arr1[b] != arr2[x]){ found = false; break; }
				}
				if(found) { output = "Reverse Rotation"; break; }
			}
		}
		return output;
	}

	//-------------------------

	function BuildResult() {
		// partResultChange(
		// 	<div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Input</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_input}</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Result</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt_time}</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result}</div>
		// 	</div>
		// );
		var part1 = Template.simple01("key1","Input",txt_input,22,22);
		var part2 = Template.simple3size("key2","Result",txt_time,txt_result,26,20,22);
		partResultChange(<div>{part1}{part2}</div>);
	}

	//--------------------------------------------------------


	return (
		<GUIset_TextArea
		title = "Array Rotation"
		desc = "Detect if some arrays are same after rotation."
		label1 = "Arrays"
		guiTxtArea = {guiTxtArea}
		guiTxtAreaChange={guiTxtAreaChange}
		buttonClick={buttonClick1}
		partResult={partResult}
		label={"Arrays"}
	/>

		// <div className="todoapp stack-large">
		// 	<GUI_Header title={"Array Rotation"} desc={"Detect if some arrays are same after rotation."} />
		// 	<div style={{ marginTop: "3em" }}> </div>

		// 	<GUI_InputTextArea
		// 		id="inputItemList"
		// 		className="textarea_001"
		// 		placeholder={"name,size,value"}
		// 		style={{ minHeight: "308px", whiteSpace: "pre-line" }}
		// 		area1Change={guiTxtAreaChange}
		// 		text1={guiTxtArea}
		// 		label={"Arrays"}
		// 	/>
		// 	<div style={{ display: "flex", marginLeft: "3%", marginRight: "3%" }}>
		// 		<button
		// 			onClick={() => buttonClick1()}
		// 			className="btn btn__primary btn__lg"
		// 			style={{ flex: 1, height: 50 }}
		// 		>
		// 			Analyze
		// 		</button>
		// 	</div>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	{partResult}
		// 	<GUI_Credit />
		// </div>
	);
};

export default ArrayRotation;
